<div class="allow-list-container">
  <div class="header">
    <h2>Access Control Management</h2>
    <div class="actions">
      <button class="refresh-btn" (click)="refreshData()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    </div>
  </div>

  <!-- Add New Entry Form -->
  <div class="add-entry-form">
    <h3>Add New Entry</h3>
    <form (ngSubmit)="addEntry()" #addForm="ngForm">
      <div class="form-row">
        <div class="form-group">
          <label for="userType">Type:</label>
          <select id="userType" [(ngModel)]="newEntry.Type" name="userType" required>
            <option value="Moderator">Moderator</option>
            <option value="AllowList">Allow List</option>
          </select>
        </div>
        <div class="form-group">
          <label for="userId">User ID (Twitch Username):</label>
          <input id="userId" type="text" [(ngModel)]="newEntry.UserID" name="userId" 
                 placeholder="Enter Twitch username" required>
        </div>
        <div class="form-group">
          <button type="submit" [disabled]="!addForm.form.valid || loading" class="add-btn">
            <mat-icon>add</mat-icon>
            Add Entry
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- Filters -->
  <div class="filters">
    <div class="filter-group">
      <label>Filter by Type:</label>
      <select [(ngModel)]="selectedType" (ngModelChange)="filterEntries()">
        <option value="">All Types</option>
        <option value="Moderator">Moderators</option>
        <option value="AllowList">Allow List</option>
      </select>
    </div>
    <div class="filter-group">
      <label>Search by User ID:</label>
      <input type="text" [(ngModel)]="searchText" (ngModelChange)="filterEntries()" 
             placeholder="Search by username...">
    </div>
  </div>

  <!-- Loading indicator -->
  <div *ngIf="loading" class="loading">
    <mat-icon class="spinner">refresh</mat-icon>
    Loading access control entries...
  </div>

  <!-- Error message -->
  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <!-- Success message -->
  <div *ngIf="successMessage" class="success-message">
    {{ successMessage }}
  </div>

  <!-- Access Control Entries Table -->
  <div class="entries-table-container" *ngIf="!loading">
    <div class="table-info">
      <span>Showing {{ filteredEntries.length }} of {{ allEntries.length }} entries</span>
    </div>
    
    <table class="entries-table">
      <thead>
        <tr>
          <th>Type</th>
          <th>User ID</th>
          <th>Added By</th>
          <th>Date Added</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let entry of filteredEntries; trackBy: trackByEntryId">
          <td>
            <span class="type-badge" [class.moderator]="entry.Type === 'Moderator'" 
                  [class.allowlist]="entry.Type === 'AllowList'">
              {{ entry.Type === 'AllowList' ? 'Allow List' : entry.Type }}
            </span>
          </td>
          <td class="user-id">{{ entry.UserID }}</td>
          <td>{{ entry.AddedBy }}</td>
          <td>{{ formatDate(entry.SK) }}</td>
          <td>
            <button class="delete-btn" (click)="removeEntry(entry)" [disabled]="loading">
              <mat-icon>delete</mat-icon>
              Remove
            </button>
          </td>
        </tr>
        <tr *ngIf="filteredEntries.length === 0">
          <td colspan="5" class="no-data">
            {{ allEntries.length === 0 ? 'No access control entries found.' : 'No entries match the current filter.' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Confirmation Modal -->
  <div *ngIf="showConfirmModal" class="modal-overlay" (click)="cancelRemove()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <h3>Confirm Removal</h3>
      <p>Are you sure you want to remove <strong>{{ entryToRemove?.UserID }}</strong> from the {{ entryToRemove?.Type === 'AllowList' ? 'Allow List' : entryToRemove?.Type }} list?</p>
      <div class="modal-actions">
        <button class="btn-secondary" (click)="cancelRemove()">Cancel</button>
        <button class="btn-danger" (click)="confirmRemove()">Remove</button>
      </div>
    </div>
  </div>
</div>
